/** Angular */
import { Injectable } from '@angular/core';
/** Rxjs */
import { Observable } from 'rxjs';
/** Enums  */
import { BydAdminUserServiceEnum } from '../enums/byd-admin-user-service.enum';
/** Models */
import { BydUserAccount, BydUserAccountInterface } from '@sixense/byd-auth-service';
/** Services */
import { BydRhsAbstractService } from '../../../shared/services/byd-rhs-abstract.service';

@Injectable({
  providedIn: 'root',
})
export class DsAdminUserService extends BydRhsAbstractService {
  /**
   * Implement inherited abstract member 'path' from BydRhsAbstractService
   */
  public path: string;

  /**
   * Get the selected user details.
   *
   * @param id The chosen user id
   * @returns Observable type `<BydUserAccount>`
   */
  public getUser(id: number): Observable<BydUserAccount> {
    this.path = `${BydAdminUserServiceEnum.GET_USER_ENDPOINT}${id}`;
    return this.getModel<BydUserAccount>();
  }

  /**
   * Create BydUserAccount instance.
   *
   * @param  jsonObject The flat json object.
   * @returns an `BydUserAccount` instance.
   */
  public createNewInstance(jsonObject: BydUserAccountInterface): BydUserAccount {
    return new BydUserAccount(jsonObject);
  }
}
